module.exports = __webpack_public_path__ + "static/img/card-back.dabe05d.png";